<template>
  <app-full-wrapper ref="wrapper" @click="close">
    <div class="app-dropdown-menu">
      <slot />
    </div>
  </app-full-wrapper>
</template>

<script>
export default {
  name: 'AppDropdownMenu',

  computed: {
    dropdown() {
      return this.findComponentInParent('AppDropdown')
    },
  },

  created() {
    this.dropdown.dropdownMenu = this
  },

  methods: {
    open() {
      this.$refs.wrapper.open()
    },

    close() {
      this.$refs.wrapper.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.app-dropdown-menu {
  background-color: #fff;
  max-height: 50vh;
  overflow-x: hidden;
  overflow-y: auto;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.app-full-wrapper {
  > .app-dropdown-menu {
    transform: translateY(100%);
    opacity: 0;
    transition: transform 400ms, opacity 400ms;
  }

  &.opened,
  &.opening {
    > .app-dropdown-menu {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
</style>
